import { useEffect } from "react";
import Hero from "@/components/home/Hero";
import CoreIdea from "@/components/home/CoreIdea";
import Showcase from "@/components/home/Showcase";
import Story from "@/components/home/Story";
import Method from "@/components/home/Method";
import ServicesEditorial from "@/components/home/ServicesEditorial";
import IndustriesEditorial from "@/components/home/IndustriesEditorial";
import Contact from "@/components/site/Contact";
import { Seo } from "@/components/seo/Seo";

const Home = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#contact" || hash === "#book") {
      setTimeout(() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }), 250);
    }
  }, []);
  return (
    <div data-testid="home-page">
      <Seo title="Viral Vision Media | Marketing built around your business, not the algorithm" description="We help food businesses and growing Australian brands turn what happens behind the scenes into content people actually want to watch, backed by strategy, paid advertising, websites and systems." />
      <Hero />
      <CoreIdea />
      <Showcase />
      <Story />
      <Method />
      <ServicesEditorial />
      <IndustriesEditorial />
      <Contact />
    </div>
  );
};

export default Home;
